<template>
    <toolbar-option>
        <template slot="primary">
            <dropdown
                :options="options"
                :value="value"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'form-data';

export default {
    name: 'form-request-type',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Form Request Type',
            value: 'POST',
        };
    },

    computed: {
        options() {
            return [
                { text: 'POST', value: 'POST' },
                { text: 'GET', value: 'GET' },
                { text: 'QUERY', value: 'QUERY' },
            ];
        },
    },

    methods: {
        onInput(valueNew) {
            this.value = valueNew;
            this.selectedElements[0].mergeElementData(CUSTOM_ATTR_NAME, { method: valueNew });
            this.onOptionChange(valueNew);
        },

        onSelectedElement() {
            let valueNew = '';

            if (this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME)) {
                valueNew = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME).method;
            }

            this.value = valueNew;
        },
    },
};
</script>
